import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RequestLoggingService } from '../../services/request-logging.service';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { PagingService } from '../../../../shared/Services/PagingService';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { RequestLoggingDetailsComponent } from '../request-logging-details/request-logging-details.component';

@Component({
  selector: 'get-request-loggings',
  templateUrl: './get-request-loggings.component.html',
  styleUrls: ['./get-request-loggings.component.scss']
})
export class GetRequestLoggingsComponent extends BaseComponent implements OnInit {
  form: FormGroup;
    constructor(
      public service: RequestLoggingService,
      route: Router,
      private diag: NbDialogService,
      private toast: NbToastrService,
      private fb: FormBuilder,
      private paging: PagingService
    ) {
      super(route, service, paging);
    }

   ngOnInit() {
      this.intitForm();
      this.loadEntities();
    }
  
    intitForm() {
      this.form = this.fb.group({
        userName: [''],
        ipAddress: [''],
      });
    }
  
  handleSearch() {
    const userNameRaw = this.form.value.userName;
    const ipAddressRaw = this.form.value.ipAddress;

    const userName = userNameRaw ? userNameRaw.trim() : '';
    const ipAddress = ipAddressRaw ? ipAddressRaw.trim() : '';

    if (!userName && !ipAddress) {
      this.toast.danger('برجاء إدخال اسم المستخدم أو عنوان الـ IP لإتمام عملية البحث', 'رسالة تحذيرية');
      return;
    }

    const searchTerms: string[] = [];

    if (userName) {
      this.form.controls['userName'].setValue(userName);
      searchTerms.push(`userName:${userName}`);
    }

    if (ipAddress) {
      this.form.controls['ipAddress'].setValue(ipAddress);
      searchTerms.push(`ipAddress:${ipAddress}`);
    }

    this.loadEntitiesWithFilter(searchTerms.join(','));
  }

    clearFilter() {
      this.form.controls['userName'].setValue('');
      this.form.controls['ipAddress'].setValue('');
      this.loadEntitiesWithFilter('');
    }
  
    detail(model) {
      if (!model || model.id == null) {
        this.toast.danger('لا يمكن عرض التفاصيل', 'معرف السجل غير متوفر');
        return;
      }
  
      this.service.getById(model.id).subscribe(
        (res) => {
          const loggingDetails = res ? res : model;
  
          this.diag.open(RequestLoggingDetailsComponent, {
            dialogClass: 'custom-dialog-height',
            context: {
              model: loggingDetails,
            },
          });
        },
        (error) => {
          console.error('Error fetching request logging details:', error);
          this.toast.danger('حدث خطأ أثناء تحميل تفاصيل السجل', 'رسالة تحذيرية');
        }
      );
    }

}

